import React from 'react';
import useShareSet from '@components/share/useShareSet';
import { sharingSelector } from '@store/overviewDashboard/sharing/selectors';
import { useSelector } from 'react-redux';
import { SHARE_SERVICE_DASHBOARD_KEYS } from '@src/components/share/utils';

// Component to populate the share store with overview dashboard data
function LatchShare() {
  const pageKey = SHARE_SERVICE_DASHBOARD_KEYS.OVERVIEW;
  const sharingState = useSelector(sharingSelector);

  useShareSet({ pageKey, state: sharingState });

  return <></>;
}

export default LatchShare;
